import { render, staticRenderFns } from "./snakeBiteOfficers.vue?vue&type=template&id=235c5271"
import script from "./snakeBiteOfficers.vue?vue&type=script&lang=js"
export * from "./snakeBiteOfficers.vue?vue&type=script&lang=js"
import style0 from "./snakeBiteOfficers.vue?vue&type=style&index=0&id=235c5271&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports